import TinyEditor from "../TinyEditor/TinyEditor";
import { tinyEditorTypes } from "../../enums/tinyEditorTypes";
export default function BlockEditor({ type, data, onChange, editable, blockId }) {
  function handleChange(value) {
    onChange(value);
  }
  switch (type) {
    case tinyEditorTypes.TEXT:
    case tinyEditorTypes.HTML:
    case tinyEditorTypes.TABLE:
    case tinyEditorTypes.LIST:
    case tinyEditorTypes.IMAGE:
      return (
        <TinyEditor
          key={blockId}
          type={type}
          value={data ?? ""}
          handleEditorChange={handleChange}
          editable={editable}
        />
      );

    default:
      return null;
  }
}
